import { toast } from "@zerodevx/svelte-toast"

export function onInteractOtherAvatar(participantId) {
  toast.push("Interactions coming soon...")
}
